export const USER_MUTED = 'USER_MUTED'
export const USER_UNMUTED = 'USER_UNMUTED'
export const SETTINGS_TRADEURL_MISSING = 'SETTINGS_TRADEURL_MISSING'
export const LEVEL_UP = 'LEVEL_UP'

export const GAMES_SPINNERS_STARTING = 'GAMES_SPINNERS_STARTING'
export const GAMES_COINFLIP_STARTING = 'GAMES_COINFLIP_STARTING'
export const GAMES_CASE_BATTLES_STARTING = 'GAMES_CASE_BATTLES_STARTING'

export const TRADE_OFFER_PENDING = 'TRADE_OFFER_PENDING'

export const TRADE_ACTIVE = 'TRADE_ACTIVE'

export const TX_STATUS = 'TX_STATUS'

export const GAME_ERROR = 'GAME_ERROR'

export const LB_REWARDS = 'LB_REWARDS'
